export class LanguageDto {
    
    idLanguage?: number;
    
    code?: string;
    
    name?: string;
    
    isDefault?: boolean;
    
    active?: boolean;

}